"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../Button"));
var _StyledTableHeader = require("./StyledTableHeader");
var _excluded = ["title", "icon"];
function TableHeaderGhostButton(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    size: "small",
    type: "ghost",
    className: "right-aligned",
    style: {
      padding: '0px'
    }
  }, rest), /*#__PURE__*/_react.default.createElement(_StyledTableHeader.StyledGhostIcon, {
    colorType: "primary",
    name: icon
  }), /*#__PURE__*/_react.default.createElement(_StyledTableHeader.StyledGhostText, {
    type: "secondary"
  }, title));
}
var _default = exports.default = TableHeaderGhostButton;